// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-angola/calculator-angola-personal-loan/calculator-angola-personal-loan.component.scss
// module id = 638
// module chunks = 0